import React, { FC, useState } from "react";

//import BackgroundSection from "components/BackgroundSection/BackgroundSection";
//import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
// import SectionHeroArchivePage from "components/SectionHeroArchivePage/SectionHeroArchivePage";
// import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
// import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
// import { TaxonomyType } from "data/types";

//import SectionGridFilterCard from "containers/ListingStayPage/SectionGridFilterCard";
import { Helmet } from "react-helmet";
import HomeGridFilterCard from "./HomeGridFilterCard";

import FooterNav from "components_custom/FooterNav/FooterNav";

//import AlltaInfo  from '../../assets/logo/allta_intro.png';
import AlltaInfo  from '../../assets/logo/allta.png';
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface ListingExperiencesPageProps {
  className?: string;
}

const Home: FC<ListingExperiencesPageProps> = ({
  className = "",
}) => {

	const handleGoReserveList = (e: any) => {
		//window.location.href = "/reserve"
		
		const element: any = document.getElementById("area_regionlist");

		let height = 0;
		const elementPosition = element.getBoundingClientRect().top + window.scrollY;
		window.scrollTo({
			top: elementPosition - height, // 50픽셀을 뺀 위치로 이동
			behavior: 'smooth' // 부드럽게 스크롤
		});
	}; //handleGoReserveList

  return (
	<>
		<div
			className={`nc-ListingExperiencesPage relative overflow-y ${className}`}
			data-nc-id="ListingExperiencesPage"
		>
			{/* <Helmet>
				<title>Allta</title>
			</Helmet> */}
		
			<div className="w-full relative isolate h-[calc(100vh-56px)] min-h-[650px] flex justify-center">
				<video 
					className="w-full absolute inset-0 -z-10 h-[calc(100vh-56px)] min-h-[650px] object-cover"
					loop 
					muted
					autoPlay
					playsInline  // Safari에서 인라인 재생을 강제
					controls={false}  // 컨트롤 숨김
					disablePictureInPicture  // PiP 모드 비활성화
					webkit-playsinline="true"  // iOS Safari 지원
					src={`${process.env.REACT_APP_SERVER_FILE}/mov/3/title.mp4`}
				/>
				
				<div className="w-full h-full">
					<div className="text-center">
						<div className="inline-flex mt-[50px]">
							<img className={"h-[150px] sm:h-[180px]"} src={AlltaInfo} />
							{/* <div className="text-left ml-2 sm:ml-4 mt-4 sm:mt-5">
								<h2 className="font-semibold tracking-tight text-white text-4xl sm:text-6xl">Allta</h2>
								<p className="text-pretty font-bold text-gray-200 text-2xl sm:text-4xl">Travel & Tours</p>
							</div> */}
						</div>
						<div className="mt-[60px] text-gray-100">
							{/* <p className="font-black text-2xl sm:text-xl drop-shadow-lg">글로벌 모터 투어의 시작은</p>
							<p className="font-black text-2xl sm:text-xl drop-shadow-lg"><span style={{color: "#dc2626"}}>올타</span>에서 함께 하세요!</p>
							<p className="font-black text-2xl sm:text-xl mt-3 drop-shadow-lg">JOIN US AT <span style={{color: "#dc2626"}}>ALLTA</span> FOR THE START</p>
							<p className="font-black text-2xl sm:text-xl mt-3 drop-shadow-lg">OF THE GLOBAL MOTOR TOUR</p> */}
							<div className="mt-[120px]">
								<button
									type="button"
									className={`ttnc-ButtonPrimary text-xl pl-4 pr-4 pt-1 pb-1 font-medium bg-white ring-1 ring-inset ring-black hover:bg-gray-400 text-black nc-Button relative h-auto inline-flex items-center justify-center transition-colors`}
									onClick={e => handleGoReserveList (e)}
								>
									지금 예약
								</button>
							</div>
						</div>
					</div>
					
				</div>
									
			</div>

			<div className="w-full flex justify-center">
				<div className="container bg-white h-screen !p-0 !m-0 lg:w-[768px]">
					{/* SECTION HERO */}

					
				
					{/* SECTION */}
					<HomeGridFilterCard className="pb-24 pl-[1rem] pr-[1rem]" />

					{/* SECTION 1 */}
					{/* <div className="relative py-16">
						<BackgroundSection />
						<SectionSliderNewCategories
						heading="Explore top destination ✈"
						subHeading="Explore thousands of destinations around the world"
						categoryCardType="card4"
						itemPerRow={4}
						categories={DEMO_CATS}
						sliderStyle="style2"
						uniqueClassName="ListingExperiencesPage"
						/>
					</div> */}

					{/* SECTION */}
					{/* <SectionSubscribe2 className="py-24 lg:py-28" /> */}
				
					<FooterNav />
				</div>
			</div>
			
		</div>
	</>
  );
};

export default Home;
